import React, { useEffect } from 'react';
import { Stack } from 'expo-router';
import { View, StyleSheet, Platform } from 'react-native';
import { AuthProvider } from '../contexts/AuthContext';
import { ThemeProvider } from '../contexts/ThemeContext';
import { ToastProvider } from '../components/toast';
import { useAuthStore } from '../store/authStore';
import { FeedbackButton } from '../components/feedback';
import { authApi } from '../shared/utils/api';
import { CreateFeedbackRequest } from '../shared/types/feedback';
import { ErrorBoundary } from '../components/ErrorBoundary';

// Initialize auth on app start
function AuthInitializer({ children }: { children: React.ReactNode }) {
  const initialize = useAuthStore((state) => state.initialize);
  
  React.useEffect(() => {
    initialize();
  }, [initialize]);
  
  return <>{children}</>;
}

// Feedback wrapper component - TEMPORARILY DISABLED
// TODO: Re-enable when feedback system is properly integrated with v2
function FeedbackWrapper() {
  // Disabled for now - return null
  return null;
  
  /*
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  
  const handleSubmitFeedback = async (feedback: CreateFeedbackRequest): Promise<void> => {
    try {
      const response = await authApi.createFeedback(feedback);
      
      if (!response || !response.success) {
        const errorMsg = response?.message || 'Failed to submit feedback';
        throw new Error(errorMsg);
      }
    } catch (error: any) {
      const errorMessage = error?.message || error?.data?.message || 'Failed to send feedback. Please try again.';
      throw new Error(errorMessage);
    }
  };

  // Only show feedback button for authenticated users
  if (!isAuthenticated) {
    return null;
  }

  return (
    <FeedbackButton
      onSubmit={handleSubmitFeedback}
      position="bottom-right"
    />
  );
  */
}

// Global styles for web
function GlobalStyles() {
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;

    const style = document.createElement('style');
    style.textContent = `
      * {
        box-sizing: border-box;
      }
      
      html, body, #root {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
      }
      
      body {
        overflow-x: hidden;
      }
      
      /* React Native Web base styles */
      div[data-testid] {
        box-sizing: border-box;
      }
      
      /* Smooth scrolling */
      html {
        scroll-behavior: smooth;
      }
      
      /* Better text rendering */
      * {
        text-rendering: optimizeLegibility;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return null;
}

export default function RootLayout() {
  return (
    <ErrorBoundary>
      <View style={styles.root}>
        <GlobalStyles />
        <ThemeProvider>
          <ToastProvider>
            <AuthProvider>
              <AuthInitializer>
                <Stack screenOptions={{ headerShown: false }}>
                  <Stack.Screen name="index" />
                  <Stack.Screen name="(auth)" />
                  <Stack.Screen name="(tabs)" />
                </Stack>
                <FeedbackWrapper />
              </AuthInitializer>
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </View>
    </ErrorBoundary>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
  } as any,
});

